// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"69a7bccf","455":"4bced880","977":"5fa6db19"}[chunkId] + ".chunk.js";
};